import { LayoutDashboard, LogOut } from "lucide-react";
import { Button } from "../../../ui/components/Button";
import * as authText from "../../../ui/components/Auth/authTypography.style.css";
import { useI18n } from "../../lib/i18n";

export function UserSetupFooter({
  showSkip,
  showDone,
  skipLoading,
  doneLoading,
  dashboardLoading,
  onSkip,
  onDone,
  onGoToDashboard,
  onLogout,
  goToTarget = "dashboard",
}: {
  showSkip: boolean;
  showDone?: boolean;
  skipLoading?: boolean;
  doneLoading?: boolean;
  dashboardLoading?: boolean;
  onSkip: () => void;
  onDone?: () => void;
  onGoToDashboard: () => void;
  onLogout: () => void;
  /** Which app "go to" targets — swaps the corner button's label/icon-tooltip. */
  goToTarget?: "dashboard" | "trainings";
}) {
  const { t, tx } = useI18n();
  const goToLabelKey =
    goToTarget === "trainings"
      ? "account.setup.footer.goToTrainings"
      : "account.setup.footer.goToDashboard";
  const goToShortLabelKey =
    goToTarget === "trainings"
      ? "account.setup.footer.trainings"
      : "account.setup.footer.dashboard";

  return (
    <footer className={authText.setupCardFooter}>
      <div className={authText.setupFooterBar}>
        <div className={authText.setupFooterCorner}>
          <div className={authText.setupFooterCornerAction}>
            <Button
              type="button"
              color="neutral"
              variant="ghost"
              size="md"
              iconOnly
              aria-label={t("shared.userMenu.logOut")}
              title={t("shared.userMenu.logOut")}
              onClick={onLogout}
            >
              <LogOut />
            </Button>
            <span className={authText.setupFooterCornerLabel} aria-hidden>
              {tx("shared.userMenu.logOut")}
            </span>
          </div>
        </div>

        <div className={authText.setupFooterSkipSlot}>
          {showDone ? (
            <Button
              type="button"
              color="primary"
              variant="solid"
              size="lg"
              fullWidth
              loading={doneLoading}
              disabled={skipLoading || dashboardLoading}
              onClick={onDone}
            >
              {tx("account.setup.footer.done")}
            </Button>
          ) : showSkip ? (
            <Button
              type="button"
              color="neutral"
              variant="ghost"
              size="lg"
              fullWidth
              loading={skipLoading}
              disabled={dashboardLoading || doneLoading}
              onClick={onSkip}
            >
              {tx("account.setup.footer.skipForNow")}
            </Button>
          ) : null}
        </div>

        <div className={authText.setupFooterCorner}>
          <div className={authText.setupFooterCornerAction}>
            <Button
              type="button"
              color="neutral"
              variant="ghost"
              size="md"
              iconOnly
              aria-label={t(goToLabelKey)}
              title={t(goToLabelKey)}
              loading={dashboardLoading}
              disabled={skipLoading || doneLoading}
              onClick={onGoToDashboard}
            >
              <LayoutDashboard />
            </Button>
            <span className={authText.setupFooterCornerLabel} aria-hidden>
              {tx(goToShortLabelKey)}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
